export default function NotificationSettings(){
    return(
        <div>
            <div className="text-center">Notification Settings</div>
        </div>
    )
}